import React, { useMemo, useState } from "react";
import { Button, Form, Modal, Select } from "antd";
import { useAppSelector } from "../../..";
import { checkIsLoading, getSelectOptions, getFio } from "../../../lib/utils";
import { User } from "../../../lib/interfaces/User";
import { AccountCreateActiveModal } from "../types/AccountCreateActiveModal";
import { CreateAccountData } from "../types/CreateAccountData";
import { SetActiveModal } from "../../../lib/utils/useActiveModal";

interface ResponsibleUserSelectModalProps {
  visible: boolean;
  setActiveModal: SetActiveModal<AccountCreateActiveModal>;
  onSubmit: (user: User) => void;
  responsibleUserFormData: CreateAccountData["responsibleUser"];
}

export const ResponsibleUserSelectModal = (props: ResponsibleUserSelectModalProps) => {
  const { visible, setActiveModal, onSubmit, responsibleUserFormData } = props;
  const { allUsers, allUsersUsersLoading } = useAppSelector((state) => state.accountsTs);
  const [selectedUser, setSelectedUser] = useState<User | undefined>();

  const [modalForm] = Form.useForm<{ userId: number }>();

  const onCancel = () => {
    modalForm.resetFields();
    setSelectedUser(undefined);
    setActiveModal("");
  };

  const onFinish = () => {
    if (selectedUser) {
      onSubmit(selectedUser);
    }
    onCancel();
  };

  // Список пользователей доступных для выбора, за исключением ранее выбранных
  const userInfoList = useMemo(() => {
    const responsibleUserFormDataIds = responsibleUserFormData?.map(({ id }) => id) || [];
    return allUsers
      .filter(({ id }) => !responsibleUserFormDataIds.includes(id))
      .map((user) => ({
        user,
        id: user.id,
        name: getFio(user.userInfo),
      }));
  }, [allUsers, responsibleUserFormData]);

  const footer = (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Button style={{ marginRight: "20px", width: "100px" }} onClick={onCancel}>
        Отмена
      </Button>
      <Button
        type="primary"
        onClick={modalForm.submit}
        style={{ width: "100px" }}
        disabled={userInfoList.length === 0}
      >
        Сохранить
      </Button>
    </div>
  );

  return (
    <Modal
      title={<h3 style={{ color: "#58647C" }}>Менеджеры B2O</h3>}
      footer={footer}
      visible={visible}
      onCancel={onCancel}
    >
      <Form layout="vertical" onFinish={onFinish} form={modalForm}>
        <Form.Item
          name="userId"
          label={<span style={{ color: "#778899" }}>Выберите пользователя</span>}
          rules={[
            {
              required: true,
            },
          ]}
          className="form-item-required__hidden-error"
        >
          <Select
            allowClear
            options={getSelectOptions({
              list: userInfoList,
            })}
            disabled={userInfoList.length === 0}
            placeholder={userInfoList.length === 0 ? "Нет доступных пользователей" : ""}
            loading={checkIsLoading(allUsersUsersLoading)}
            onSelect={(e, { option }) => {
              setSelectedUser(option.user);
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
